module.exports = __webpack_public_path__ + "img/argent.3ed55622.jpeg";